import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {  Session, Api } from '../services/index';
import { NotificationsService } from 'angular2-notifications';
import { Environment } from '../app.environment';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'how-to-schedule',
    templateUrl: './how-to-schedule.html',
    styleUrls: ['./how-to-schedule.css']

  })

export class HowToSchedulePage {
    patientId: number;
    typeOfVisit: string;
    linkToProviderScheduleData:string;
    loading:boolean = false;
    visitsAvailable:boolean = false;
    public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor( private route: ActivatedRoute, private router: Router, public session: Session, private service: NotificationsService,private env: Environment, private api:Api) {  
    this.patientId = this.route.snapshot.params['patientId'] || ''; 
    this.typeOfVisit = '';
    
  }
  
  
  showBio = false;

  gotobio(){
    
      if(this.typeOfVisit === 'Video' || this.typeOfVisit === 'Phone'){
        this.session.intakeBhVisitModality = this.typeOfVisit;
        this.router.navigate(['/select-provider/' + this.patientId ]);
      }else{
        this.service.error('Please select a valid visit type to continue');
      }
     
  }

  ngOnInit() {
    if (this.session && this.session.intakeLob ==='BH') {
      this.typeOfVisit = "Video";
      this.session.intakeBhVisitModality = this.typeOfVisit;
      this.checkSchedules('Video');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  gotoSchedule(){
    this.session.providerBio = null;
    this.session.intakeRequestedProviderId = null;
    if(this.typeOfVisit === 'Video' || this.typeOfVisit === 'Phone'){
      this.session.intakeBhVisitModality = this.typeOfVisit;
      this.router.navigate(['/exam-appointment/' + this.patientId ]);
    }else{
      this.service.error('Please select a valid visit type to continue');
    }

   
  }
  
  checkSchedules(event){
    this.loading = true;
    //build the URL
    if (this.session.intakeLob === 'BH') {
      this.linkToProviderScheduleData = 'v2/schedule/' + this.session.clientIntake.lineOfBusiness + '/type/Video/state/' + this.session.clientIntake.currentState + '/patient/' + this.session.intakeBhType;

    } else {
      this.linkToProviderScheduleData = 'v2/schedule/' + this.session.clientIntake.lineOfBusiness + '/type/' + event.target.value + '/state/' + this.session.clientIntake.currentState + '/patient/' + this.session.intakeBhType;
    }
    //subscribe to the AJAX (assigned to a variable in case we want to unsubscribe in the future)
    this.api.getAvailableSchedules(this.linkToProviderScheduleData).pipe(takeUntil(this.destroy$)).subscribe(schedules => {
      //clear spinner
      this.loading = false;
    }), (error) => {
      alert('There was an issue retreving schedules');
      this.loading = false;
      console.log(error);
    };
  }
}
